import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  TableBaseWrapper,
  TableColumnBaseWrapper,
  TableRowBaseWrapper,
  TableSectionBaseWrapper
} from './styled'

class TableSectionBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
    } = this.props

    return (
      <TableSectionBaseWrapper
        className={ClassNames(
          'table-section-base',
          // Option
          className
        )}
        theme={{
          // Default
        }}
      >
        {children}
      </TableSectionBaseWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}

class TableRowBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default,
      onClick = () => { },
      pointer,
    } = this.props

    return (
      <TableRowBaseWrapper
        onClick={onClick}
        className={ClassNames(
          'table-row-base',
          // Option
          className,
          { 'is-cursor-pointer': pointer }
        )}
        theme={{
          // Default
        }}
      >
        {children}
      </TableRowBaseWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,
    pointer: PropTypes.bool,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}

class TableColumnBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      maxWidth,
      minWidth,
      minHeight,
      padding,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingHorizontal,
      paddingVertical,
      bgColor,
      borderWidth,
      borderStyle,
      borderColor,
      borderBottomWidth,
      borderBottomStyle,
      borderBottomColor,
      borderTopRightRadius,
      borderTopLeftRadius,
      borderBottomRightRadius,
      borderBottomLeftRadius,
      alignCenter,
      alignRight,
      sortButtonDescending,
      sortButtonAscending,
      onClickSort,
      sortAscending,
      sortButtonSpacingRight,
      title,
    } = this.props

    return (
      <TableColumnBaseWrapper
        className={ClassNames(
          'table-column-base',
          { 'is-text-align-center': alignCenter },
          { 'is-text-align-right': alignRight },
          // Option
          className
        )}
        theme={{
          // Default
          maxWidth,
          minWidth,
          minHeight,
          padding,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          paddingHorizontal,
          paddingVertical,
          bgColor,
          borderWidth,
          borderStyle,
          borderColor,
          borderBottomWidth,
          borderBottomStyle,
          borderBottomColor,
          borderTopRightRadius,
          borderTopLeftRadius,
          borderBottomRightRadius,
          borderBottomLeftRadius,
          sortButtonSpacingRight
        }}
        title={title}
      >
        {children}
        {(sortButtonAscending || sortButtonDescending) &&
          <div className='table-sort-button-base'
            onClick={onClickSort}
            onKeyDown={() => { }}
            role='button'
            tabIndex={0}
          >
            {sortAscending ?
              sortButtonAscending
              :
              sortButtonDescending
            }
          </div>
        }
      </TableColumnBaseWrapper>
    )
  }

  static defaultProps = {
    sortButtonSpacingRight: '0' // if zero value, you should use string instead number
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingLeft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingHorizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    paddingVertical: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    bgColor: PropTypes.string,
    borderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderBottomWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderBottomStyle: PropTypes.string,
    borderBottomColor: PropTypes.string,
    borderTopRightRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderTopLeftRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderBottomRightRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderBottomLeftRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    alignCenter: PropTypes.bool,
    alignRight: PropTypes.bool,
    sortButtonDescending: PropTypes.any,
    sortButtonAscending: PropTypes.any,
    onClickSort: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    sortAscending: PropTypes.any,
    sortButtonSpacingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}

export class TableBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      overflowVisible,
      // Default
    } = this.props

    return (
      <TableBaseWrapper
        className={ClassNames(
          'table-base',
          // Option
          className
        )}
        theme={{
          // Default
        }}
      >
        {
          overflowVisible ? (
            <div className='table-overflow-visible'>
              {children}
            </div>
          ) : (
            <div className='table-scroll-base'>
              {children}
            </div>
          )
        }

      </TableBaseWrapper>
    )
  }

  static Section = TableSectionBase
  static Row = TableRowBase
  static Column = TableColumnBase

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,
    overflowVisible: PropTypes.bool,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
